import { render, staticRenderFns } from "./sale-payment-export.vue?vue&type=template&id=0b7fd875&scoped=true&"
import script from "./sale-payment-export.vue?vue&type=script&lang=js&"
export * from "./sale-payment-export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fd875",
  null
  
)

export default component.exports